module.exports = __webpack_public_path__ + "img/img-mission-600-x-170.8a58b011.png";